import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "hhn-commons";

type ButtonRevokeType = {
  onClick: () => void;
};

const ButtonRevoke = ({ onClick }: ButtonRevokeType) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <Button
      variant="outlined"
      color="warning"
      data-testid="referral-revoke-btn"
      fullWidth
      onClick={onClick}
      style={{ textTransform: "none" }}
    >
      {tNs("referral.revokeReferral")}
    </Button>
  );
};

export default ButtonRevoke;
